import isEqual from 'lodash/isEqual';

import { Box } from '@hivebrite/design-system/Box';
import { ReactSelectInput } from '@hivebrite/design-system/Inputs';

import { sortByItems } from './sortByItems';

const SortBy = ({ onChange, value, isLoading }) => {
  const currentSortBy =
    sortByItems.find((item) => isEqual(item, value)) || sortByItems[0];

  return (
    <>
      <Box
        as="label"
        font="body-semibold-asphalt"
        htmlFor="comment_sort_by"
        mr={2}
      >
        {__('Sort by:')}
      </Box>
      <Box display="block" minWidth={165}>
        <ReactSelectInput
          id="comment_sort_by"
          name="comment_sort_by"
          onChange={onChange}
          options={sortByItems}
          value={currentSortBy}
          variant="small"
          disabled={isLoading}
        />
      </Box>
    </>
  );
};

export default SortBy;
